// src/utils/request.js
import axios from 'axios'
import store from './store'

// 创建axios实例
const service = axios.create({
  baseURL: process.env.VUE_APP_API_URL, // 使用环境变量中的基础URL
  timeout: 10000, // 请求超时时间
  headers: {
    'Content-Type': 'application/json;charset=utf-8'
  }
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 在这里可以统一处理请求前的操作，例如添加token等
    const token = store.state.token
    // const token = localStorage.getItem('token')
    if (token && !config.url.includes('/ajax/auth')) {
      config.headers.Authorization = 'Bearer ' + token
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    // 在这里可以统一处理响应数据
    const res = response.data
    // 根据你的后端返回结构自定义处理
    // if (res.code !== 200) {
    //   return Promise.reject(new Error(res.message || 'Error'))
    // } else {
    //   return res
    // }
    return res
  },
  error => {
    // 在这里可以统一处理错误
    console.error('请求错误:', error)
    return Promise.reject(error)
  }
)

export default service